import Resource from './Resource';

export default class VoiceResource implements Resource {
  constructor(
    public id: number,
    public sceneIds: number[] | undefined,
    public audioUrl: string,
  ) {}
}
